<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <a id="translators"></a>
        <h4 class="title is-4">
          <i class="fas fa-users"></i>&nbsp;Translators
        </h4>
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        These awesome people have contributed to translations of ...
        <br/><br/>
        <table class="table">
          <tr>
            <th>
              Language
            </th>
            <th>
              Translator
            </th>
          </tr>
          <tr>
            <td>
              ...
            </td>
            <td>
              ...
            </td>
          </tr>
        </table>
        <br/><br/>
        Thanks for making this app more accessible and useful!
      </div>
    </div>
  </div>
</template>
